import { createFileRoute } from "@tanstack/react-router";
import ListingsV2Demo from "@/pages/ListingsV2Demo";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/demo/")({
  head: () => routeHead("/de/demo/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ListingsV2Demo />
  );
}
